export default [
    {
        name: 'hotspot is turned off',
        key: 'hotspot-is-turned-off',
        comply: {
            en: 'Hotspot is turned off',
            vi: 'Hotspot đã tắt',
        },
        violate: {
            en: 'Please turn off your hotspot',
            vi: 'Vui lòng tắt Hotspot',
        },
        description: {
            en: 'Your device hotspot must be turned off due to organization policies',
            vi: 'Để tuân thủ chính sách An toàn thông tin, thiết bị của bạn cần tắt Hotspot',
        }
    },
    {
        name: 'network connection is secured',
        key: 'network-connection-is-secured',
        comply: {
            en: 'Network connection is secured',
            vi: 'Kết nối mạng được bảo mật',
        },
        violate: {
            en: 'Please secure your network connection',
            vi: 'Vui lòng bảo mật kết nối mạng',
        },
        description: {
            en: 'Your connection is using an unsecured network protocol.',
            vi: 'Kết nối của bạn đang sử dụng giao thức mạng không bảo mật.',
        }
    },
    {
        name: 'external-storage-is-not-used',
        key: 'external-storage-is-not-used',
        comply: {
            en: 'External storage is not used',
            vi: 'Thiết bị không kết nối với bộ nhớ ngoài',
        },
        violate: {
            en: 'Please eject your external storage',
            vi: 'Vui lòng rút bộ nhớ ngoài',
        },
        description: {
            en: 'External storage (USB, HDD, SSD, …) is not allowed on your device',
            vi: 'Thiết bị của bạn không được phép kết nối với bộ nhớ ngoài (USB, HDD, SDD, …)',
        }
    },
    {
        name: 'antivirus-protection-mode-is-turned-on',
        key: 'antivirus-protection-mode-is-turned-on',
        comply: {
            en: 'Antivirus protection mode is on',
            vi: 'Phần mềm diệt virus đang được sử dụng',
        },
        violate: {
            en: 'Please turn on Antivirus',
            vi: 'Vui lòng bật & sử dụng Antivirus',
        },
        description: {
            en: 'Antivirus protection mode is off. Make sure to turn it on before connecting to any application',
            vi: 'Để bảo vệ thiết bị của bạn, phần mềm diệt virus cần được cài đặt và sử dụng',
        }
    },
    {
        name: 'os-version-is-windows-10-or-above',
        key: 'os-version-is-windows-10-or-above',
        comply: {
            en: 'OS version is Windows 10 or above',
            vi: 'Hệ điều hành từ Windows 10 trở lên',
        },
        violate: {
            en: 'Please update OS to Windows 10+',
            vi: 'Hệ điều hành không tương thích',
        },
        description: {
            en: 'Your Operation System (OS) must be Windows 10 or above',
            vi: 'Bạn cần sử dụng hệ điều hành từ Windows 10 trở lên',
        }
    },
    {
        name: 'uac-is-turned-on',
        key: 'uac-is-turned-on',
        comply: {
            en: 'User Account Control (UAC) is on',
            vi: 'User Account Control (UAC) đã được bật',
        },
        violate: {
            en: 'Please turn on UAC',
            vi: 'Vui lòng bật UAC',
        },
        description: {
            en: 'User Account Control (UAC) must be turned on to protect your device',
            vi: 'Để bảo vệ thiết bị của bạn, User Account Control (UAC) cần được bật',
        }
    },
    {
        name: 'os-security-is-up-to-date',
        key: 'os-security-is-up-to-date',
        comply: {
            en: 'OS security up to date',
            vi: 'Hệ điều hành đã được cập nhật',
        },
        violate: {
            en: 'Please update your OS',
            vi: 'Vui lòng cập nhật hệ điều hành',
        },
        description: {
            en: 'Your Operation System (OS) must be updated',
            vi: 'Bạn đang sử dụng hệ điều hành phiên bản cũ, vui lòng cập nhật',
        }
    },
    {
        name: 'camera-is-turned-off',
        key: 'camera-is-turned-off',
        comply: {
            en: 'Camera is turned off',
            vi: 'Camera đã được tắt',
        },
        violate: {
            en: 'Please turn off your camera',
            vi: 'Vui lòng tắt camera',
        },
        description: {
            en: 'Your camera must be turned off due to organization policies',
            vi: 'Để tuân thủ chính sách An toàn thông tin, camera cần được tắt',
        }
    },
    {
        name: 'bitlocker-is-enabled',
        key: 'bitlocker-is-enabled',
        comply: {
            en: 'Bitlocker is enabled',
            vi: 'Thiết bị đã được mã hóa với Bitlocker',
        },
        violate: {
            en: 'Please enable Bitlocker',
            vi: 'Vui lòng bật Bitlocker',
        },
        description: {
            en: 'Bitlocker must be turned on to keep your data secure',
            vi: 'Thiết bị cần được mã hóa với Bitlocker để đảm bảo an toàn thông tin',
        }
    },
    {
        name: 'user-password-is-set',
        key: 'user-password-is-set',
        comply: {
            en: 'User password is set',
            vi: 'Mật khẩu thiết bị đã được cài đặt',
        },
        violate: {
            key: 'Please set device password',
            en: 'Please set device password',
            vi: 'Vui lòng cài đặt mật khẩu',
        },
        description: {
            en: 'Your device password must be set',
            vi: 'Để tuân thủ chính sách An toàn thông tin, thiết bị của bạn cần được cài đặt mật khẩu',
        }
    },
    {
        name: 'shared-folder-is-turned-off',
        key: 'shared-folder-is-turned-off',
        comply: {
            en: 'Shared folder is turned off',
            vi: 'Tính năng chia sẻ thư mục đã tắt',
        },
        violate: {
            en: 'Please turn off shared folder',
            vi: 'Vui lòng tắt chia sẻ thư mục',
        },
        description: {
            en: 'Shared folder must be disabled due to organization policies',
            vi: 'Một hoặc một số thư mục đang được bật chế độ chia sẻ. Vui lòng tắt chia sẻ để tuân thủ chính sách An toàn thông tin',
        },
    },
    {
        name: 'bluetooth-is-turned-off',
        key: 'bluetooth-is-turned-off',
        comply: {
            en: 'Bluetooth is turned off',
            vi: 'Bluetooth đã tắt',
        },
        violate: {
            en: 'Please turn off Bluetooth',
            vi: 'Vui lòng tắt Bluetooth',
        },
        description: {
            en: 'Bluetooth must be turned off  due to organization policies',
            vi: 'Để tuân thủ chính sách An toàn thông tin, thiết bị của bạn cần tắt Bluetooth',
        }
    },
]
